<mat-card appearance="outlined" class="col-12 stretch">
  <mat-card-header> Case Usage Details </mat-card-header>
  <mat-card-content class="row">
    <div class="col-12">
      <mat-form-field>
        <mat-label>Group By</mat-label>
        <mat-select
          placeholder="Group By"
          [(ngModel)]="selectedGroup"
          (selectionChange)="getConfigData()"
        >
          @for (groupByItem of groupByItems; track groupByItem) {
            <mat-option [value]="groupByItem.value">{{
              groupByItem.viewValue
            }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    @if (!solutionId || solutionId === 'ALL') {
      <div class="data-input-warning">
        Note: A solution must be selected at the top of the page to launch to
        Case Explorer
      </div>
    }
    @if (!loading && (!start || !end)) {
      <div class="data-input-warning">
        Please select a date range from the input at the top of the page.
      </div>
    }
    <div class="col-12 data-container">
      @if (gridData.data) {
        <kendo-grid
          #usageGrid="kendoGrid"
          class="w-100 case-stats-activity-grid"
          [data]="gridData"
          [pageable]="true"
          [style.maxHeight.px]="390"
          [size]="'medium'"
          [filterable]="'menu'"
          [sortable]="sortSettings"
          [skip]="skip * 1"
          [pageSize]="take"
          [sort]="sort"
          [filter]="filter"
          [columnMenu]="{ columnChooser: false }"
          [navigable]="true"
          (dataStateChange)="dataStateChange($event)"
        >
          @for (header of gridData.headers; track $index) {
            <kendo-grid-column
              [field]="header.DataField"
              [title]="header.Label"
              [sortable]="header.Sort"
              [filterable]="header.Filter"
            >
              @if (header.Sort || header.Filter) {
                <ng-template
                  let-service="service"
                  kendoGridColumnMenuTemplate
                  class="test"
                >
                  @if (header.Sort) {
                    <kendo-grid-columnmenu-sort
                      [column]="header"
                      [service]="service"
                    >
                      <kendo-grid-messages
                        [sortAscending]="getFilterMenuText(header.Type, 'asc')"
                        [sortDescending]="
                          getFilterMenuText(header.Type, 'desc')
                        "
                      />
                    </kendo-grid-columnmenu-sort>
                  }
                  @if (
                    header.Filter &&
                    gridData.dropdowns &&
                    gridData.dropdowns[header.DataField]
                  ) {
                    <kendo-grid-columnmenu-filter
                      [column]="header"
                      [service]="service"
                    >
                      <ng-template
                        let-filter="filter"
                        let-filterService="filterService"
                        kendoGridFilterMenuTemplate
                      >
                        <kendo-multiselect
                          textField="{{ header.DataField }}"
                          valueField="{{ header.DataField }}"
                          style="width: 220px"
                          [data]="gridData.dropdowns[header.DataField]"
                          [valuePrimitive]="true"
                          [value]="filter | filterValues"
                          (valueChange)="
                            searchFilterValueChange(
                              $event,
                              header.DataField,
                              filterService
                            )
                          "
                        />
                      </ng-template>
                    </kendo-grid-columnmenu-filter>
                  }
                </ng-template>
              }
              @if (
                ['unitname', 'repname', 'username'].includes(
                  header.DataField.toLowerCase()
                )
              ) {
                <ng-template let-dataItem kendoGridCellTemplate>
                  {{ dataItem[header.DataField] }}

                  <button
                    mat-icon-button
                    class="pull-right"
                    color="primary"
                    matTooltip="Launch Case Explorer"
                    [disabled]="!solutionId || solutionId === 'ALL'"
                    (click)="launchCe(dataItem)"
                  >
                    <mat-icon>find_in_page</mat-icon>
                  </button>
                </ng-template>
              }
            </kendo-grid-column>
          }
          <ng-template
            let-totalPages="totalPages"
            let-currentPage="currentPage"
            kendoPagerTemplate
          >
            <kendo-pager-prev-buttons />
            <kendo-pager-numeric-buttons [buttonCount]="5" />
            <kendo-pager-next-buttons />
            <kendo-pager-input />
            <kendo-pager-info />
            <kendo-pager-page-sizes [pageSizes]="pageSizeOptions" />
          </ng-template>
        </kendo-grid>
      }
    </div>
  </mat-card-content>
  <ngx-loading [show]="loading" [config]="{ fullScreenBackdrop: false }" />
</mat-card>
